// ===========================================
// All Notes Dialog Component
// ===========================================

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Note } from '../../../api/notes.api';
import NoteItem from './NoteItem';

interface Props {
  open: boolean;
  studentName: string;
  notes: Note[];
  onClose: () => void;
}

/**
 * Dialog showing all notes for a student
 */
export default function AllNotesDialog({ open, studentName, notes, onClose }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>All Notes for {studentName}</DialogTitle>
      <DialogContent dividers>
        {notes && notes.length > 0 ? (
          notes.map((note) => <NoteItem key={note.id} note={note} showFullContent />)
        ) : (
          <Typography color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
            No notes found
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
